import { useMutation } from '@tanstack/react-query';
import { useNotification } from '../useNotification';
import { useFetchApi } from '../useFetchApi';
import { WebhookSecret } from '../../shared/types';

export const useWebhookSecret = () => {
  const fetch = useFetchApi();
  const { showErrorWithResponse } = useNotification();

  return useMutation({
    mutationFn: (id: string) =>
      fetch(`webhooks/${id}/secret`) as Promise<WebhookSecret>,
    onError: showErrorWithResponse,
  });
};
